function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, CheckBox, Select, Text } from 'grommet';
import { FormClose } from 'grommet-icons';
import _ from 'lodash';
import styled from 'styled-components';
import Loader from 'granite-admin/core/components/Loader';
const Parent = styled(Box)`
  button {
    border: none;
  }
`;
const Autocomplete = ({
  fetchData,
  labelKey,
  multiple,
  uniqueId,
  placeholder,
  onChange: onChangeCallback,
  defaultSelected,
  onBlur,
  ...rest
}) => {
  const defaultOptions = new Set([]);
  // const [searching, setSearching] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(defaultOptions);
  const [options, setOptions] = useState(defaultOptions);

  // FIXME: handle cancelling requests
  // TODO: add searching placeholder

  useEffect(() => {
    if (defaultSelected?.length) {
      const updatedOptions = new Set([]);
      defaultSelected.forEach(opt => updatedOptions.add({
        name: opt.name,
        pk: opt.pk
      }));
      setSelectedOptions(new Set([...updatedOptions]));
    }
  }, []);
  const selectedOptionRef = useRef(null);
  useEffect(() => {
    selectedOptionRef.current.onclick = onBlur;
  }, [onBlur]);
  useEffect(() => {
    handleSearch('');
  }, []);
  const clearSelectedOptions = () => {
    onChangeCallback([]);
    setSelectedOptions(defaultOptions);
  };
  const handleSearch = async value => {
    if (value || value === '' || value === 0) {
      // setSearching(true);
      setOptions(new Set([...selectedOptions, {
        searching: true
      }]));
      const results = await fetchData(value);
      // setSearching(false);
      setOptions(_.uniqBy([...selectedOptions, ...results], uniqueId));
    }
  };
  const debouncedHandleSearch = _.debounce(handleSearch, 800);
  const handleOnChange = ({
    value
  }) => {
    const updatedOptions = new Set([...selectedOptions]);
    const isSelected = updatedOptions.has(value);
    if (isSelected) {
      updatedOptions.delete(value);
    } else {
      if (multiple) {
        updatedOptions.add(value);
      } else {
        updatedOptions.clear();
        updatedOptions.add(value);
      }
    }
    setSelectedOptions(updatedOptions);
    onChangeCallback([...updatedOptions]);
  };
  const renderOption = option => {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "row",
      align: "center",
      pad: "small",
      flex: false
    }, option.hasOwnProperty('searching') ? /*#__PURE__*/React.createElement(Box, {
      flex: true,
      alignSelf: "center",
      align: "center",
      justify: "center"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "15px"
    })) : /*#__PURE__*/React.createElement(CheckBox, {
      checked: selectedOptions.has(option),
      label: /*#__PURE__*/React.createElement(Text, null, option[labelKey]),
      onChange: () => {}
    }));
  };
  const renderSelectedOptions = () => {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "row",
      gap: "xsmall",
      pad: {
        left: 'small',
        vertical: 'small'
      },
      align: "center",
      flex: true
    }, /*#__PURE__*/React.createElement(Box, {
      background: "brand",
      round: "medium",
      align: "center",
      justify: "center",
      pad: {
        horizontal: 'xsmall'
      },
      style: {
        minWidth: '21px'
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, selectedOptions.size)), /*#__PURE__*/React.createElement(Box, {
      flex: true
    }, /*#__PURE__*/React.createElement(Text, {
      truncate: true
    }, [...selectedOptions].map(opt => opt[labelKey]).join(', '))), /*#__PURE__*/React.createElement("span", {
      onFocus: event => event.stopPropagation(),
      onClick: event => {
        event.preventDefault();
        event.stopPropagation();
        clearSelectedOptions();
      }
    }, /*#__PURE__*/React.createElement(Box, {
      background: "gray",
      round: "full"
    }, /*#__PURE__*/React.createElement(FormClose, {
      style: {
        width: '14px',
        height: '14px'
      }
    }))));
  };
  return /*#__PURE__*/React.createElement(Parent, null, /*#__PURE__*/React.createElement(Select, _extends({
    ref: selectedOptionRef,
    closeOnChange: !multiple,
    emptySearchMessage: "No result found",
    icon: true,
    onChange: handleOnChange,
    onSearch: debouncedHandleSearch,
    options: [...options],
    placeholder: placeholder,
    searchPlaceholder: "Type to search",
    value: selectedOptions.size > 0 ? renderSelectedOptions() : []
  }, rest), renderOption));
};
Autocomplete.defaultProps = {
  multiple: false,
  onChange: () => {},
  uniqueId: 'pk',
  placeholder: '',
  onBlur: () => {}
};
Autocomplete.propTypes = {
  fetchData: PropTypes.func,
  labelKey: PropTypes.string,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  uniqueId: PropTypes.string
};
export default Autocomplete;